export default __webpack_public_path__ + "static/media/superbet_receipt.22231064.jpg";